export default "__VITE_ASSET__19b05c4d__"